export default "/bg/sm/day2.jpg"